module.exports = __webpack_public_path__ + "img/landing-page-map.31cf81d6.svg";